import { Grid } from '@mui/material';

import { type ModelType } from 'app/main/components/hooks/useModel';
import { type LogsType } from 'app/main/components/hooks/useLogs';
import DetailsSectionWrapper, { type DetailsSectionWrapperProps } from '../components/DetailsSectionWrapper';

type DetailsSectionInfoWrapperProps = Pick<
	DetailsSectionWrapperProps,
	'className' | 'title' | 'subheader' | 'avatar' | 'headerAction' | 'children'
>;

export interface DetailsSectionInfoContentProps {
	model: any;
	sendChange: ModelType['sendChange'];
	isEdit?: boolean;
	logProps?: LogsType;
}

export default function DetailsSectionInfoWrapper(props: DetailsSectionInfoWrapperProps) {
	// const { t } = useSettings();

	return (
		<DetailsSectionWrapper
			className={props.className}
			avatar={props.avatar}
			title={props.title}
			subheader={props.subheader}
			headerAction={props.headerAction}
		>
			<Grid container spacing={1}>
				{props.children}
			</Grid>
		</DetailsSectionWrapper>
	);
}
